export default function () {
    return {
        countries: [],
        lastCountryStatesFetch: null,
        states: [],
        locations: [],
    }
}